
export type BuilderTypes = 'libs' | 'tslibs';
